import React from "react";
import Donation from "../Donation/Donation";

function Home() {
  return (
    <>
      <div className="w-full">
        <img
          src="/hero.jpg"
          alt="logo"
          className="w-full h-full max-h-[calc(100vh-80px)] object-contain md:mt-0 mt-6"
        />
        <div className="w-full bg-[#E76165] p-4 flex justify-center items-center ">
          <h2 className="font-noto font-medium text-white md:text-2xl text-md text-center">
            Help us by donating more hoodies and sweaters this winder
          </h2>
          <button className="ml-6 w-[120px] h-[40px] rounded-lg font-noto bg-black text-white text-md hover:scale-105 transition-all duration-300 ">
            Donate
          </button>
        </div>
        <Donation />
      </div>
    </>
  );
}

export default Home;
